import axios from 'axios'
import store from '@/store'
import {version} from '../../package.json'

// create axios
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api base_url
  timeout: 300000, // timeout,
  headers: {'X-Client-Version': version},
})

let tries = 0
const MAX_TRIES = 3

const err = (error) => {
  if (error.message === `Network Error`) {
    if (tries > MAX_TRIES) window._VMA.$emit('OFFLINE')
    tries++
    return Promise.reject(error)
  }

  if (!error.response) {
    return Promise.reject(error)
  }
  const {status, data} = error.response
  const {errors} = data
  let message = []
  for (let field in errors) {
    message.push(errors[field])
  }

  switch (status) {
    case 400: {
      const text = typeof data === 'string' ? data : (data && data.message)
      const skipSnackbar = typeof data === 'string' && data.indexOf('does not belong to provided company') !== -1
      if (text && !skipSnackbar) {
        window._VMA.$emit('SHOW_SNACKBAR', {
          show: true,
          text,
          color: 'red',
        })
      }
      break
    }
    
    case 422:
      window._VMA.$emit('SHOW_SNACKBAR', {
        show: true,
        text: message,
        color: 'red',
      })
      break

    case 401:
      window._VMA.$emit('AUTH_FAILED')
      break

    case 403:
      if (data.match(/^Access Denied.*VPN.*/ui)) {
        window._VMA.$emit('AUTH_FAILED')
        setTimeout(() => window._VMA.$emit('SHOW_SNACKBAR', {
          show: true,
          text:data,
          color: 'red',
        }), 500);
      }
      window._VMA.$emit('ACCESS_DENIED')
      break

    case 429:
      window._VMA.$emit('TOO_MANY_REQUESTS', {data})
      break

    case 500:
      window._VMA.$emit('SERVER_ERROR')
      break
    
    case 503:
      window._VMA.$emit('SHOW_SNACKBAR', {
        show: true,
        text: (typeof data === 'string' ? data : data.message),
        color: 'red',
      })
      break

    default:
      break
  }

  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use((config) => {
  config.headers['Content-Type'] = 'application/json'
  if (store.getters.getAccessToken)
    config.headers['Authorization'] = 'Bearer ' + store.getters.getAccessToken

  return config
}, err)

// response interceptor
service.interceptors.response.use(({data, config}) => {
  if (tries > MAX_TRIES) {
    window._VMA.$emit('SHOW_SNACKBAR', {
      show: true,
      text: 'Your connection to the trading server is restored.',
      color: 'green',
    })
    window._VMA.$emit('ONLINE')
    tries = 0
  }
  if (['put', 'post', 'delete', 'patch'].includes(config.method) && data.meta) {
    window._VMA.$emit('SHOW_SNACKBAR', {
      text: data.meta.message,
      color: 'success',
    })
  }
  if (data.error !== undefined) {
    window._VMA.$emit('API_FAILED', data.error)
  }

  return data
}, err)

export default service
